export { default, HoldsList } from './HoldsList';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsList/index.js